<script lang="ts" setup name="CookiePolicyCollapsible">
import BaseCollapsible from '~/components/BaseCollapsible.vue';
import Icon from '~/components/Icon.vue';

const { title = '', description = '' } = defineProps<{
  title?: string;
  description?: string;
}>();
</script>

<template>
  <BaseCollapsible>
    <template #trigger="{ toggle, isOpen }">
      <button
        type="button"
        class="flex w-full items-center justify-between py-5"
        @click="toggle"
      >
        <p class="text-primary-6">
          {{ title }}
        </p>
        <Icon
          icon="mdi:chevron-right"
          class="transform text-primary-6 transition-transform"
          :class="{ 'rotate-90': isOpen }"
        />
      </button>
    </template>

    <div class="border-t border-charcoal-2 bg-charcoal-1 p-6">
      <span v-html="description" />
    </div>
  </BaseCollapsible>
</template>
